import { useMemo } from "react";
import { useGetDepreciationReportQuery } from "../api";

function formatDateLocal(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function useDepreciationPage() {
  const today = useMemo(() => new Date(), []);
  const formattedDate = formatDateLocal(today);

  const { data, isLoading, isFetching, isError, refetch } = useGetDepreciationReportQuery(
    { report_date: formattedDate },
  );

  return {
    reportDate: today,
    depreciationReport: data,
    isLoading,
    isFetching,
    isError,
    refetch,
  };
}
